import React from "react";
import { ProgressBar } from "react-bootstrap";

export default function InfoEvent({ title, ticketsValidated, ticketsSold }) {
  return (
    <div className="box">
      <h3 style={{ marginBottom: "20px" }}>{title}</h3>
      <div className="ticket">
        <p>Entradas validadas:</p>
        <p className="bold"> {ticketsValidated}</p>
      </div>
      <div className="ticket">
        <p>Entradas vendidas: </p>
        <p className="bold">{ticketsSold}</p>
      </div>
      <ProgressBar
        striped
        animated
        variant="info"
        now={Math.round((ticketsValidated * 100) / ticketsSold)}
        className="mt-4"
      />
    </div>
  );
}
